import r from"@emotion/styled";const a=r.div`
  label: datepicker;
  display: flex;
  gap: 8px;
  flex-direction: ${({disabledIfY:e})=>!e&&"row-reverse"};
`;export{a as DatePickerWrapperStyled};
